import { render } from "./AIMessageBubble.vue?vue&type=template&id=1dde5186&scoped=true"
import script from "./AIMessageBubble.vue?vue&type=script&lang=js"
export * from "./AIMessageBubble.vue?vue&type=script&lang=js"

import "./AIMessageBubble.vue?vue&type=style&index=0&id=1dde5186&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dde5186"]])

export default __exports__